import { Injectable } from '@angular/core';
import { HttpService } from '../../../shared/services/http/http-client.service';
import { environment } from '../../../../environments/environment';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class GeraPedidoPrePagoService {

  constructor(
    private httpService: HttpService
  ) { } 

  buscaLimiteGlobal(data: any, successHandle:Function, errorHandle:Function) {

    this.httpService.doGet('/enterprise/balanceLimit', data, successHandle, errorHandle);

  } 

  buscaSaldoGlobal(data: any, successHandle:Function, errorHandle:Function) {

    this.httpService.doGet('/enterprise/balanceLimit', data, successHandle, errorHandle);

  }

  inserePedido(data: any, successHandle: Function, errorHandle: Function) {
   
    return this.httpService.doPost('/prepago/insertPrePaidOrder', data, successHandle, errorHandle);
    
  }
  
}
